import React from 'react';
import { ShieldCheck, Clock, Award, CheckCircle2 } from 'lucide-react';

const About = () => {
  const brandBlue = '#004e6e';
  const brandRed = '#ff4a4a';

  const stats = [
    { label: 'Jahre Erfahrung', value: 'Mehrere jahre' },
    { label: 'Zufriedene Kunden', value: '100%' },
  ];

  const valueProps = [
    {
      title: "Fachkompetenz",
      desc: "Zertifizierte Spezialisten für moderne Haustechnik.",
      icon: <ShieldCheck size={28} />
    },
    {
      title: "Pünktlichkeit",
      desc: "Wir respektieren Ihre Zeit – garantiert und zuverlässig.",
      icon: <Clock size={28} />
    },
    {
      title: "Schweizer Qualität",
      desc: "Höchste Standards bei Material und Ausführung.",
      icon: <Award size={28} />
    }
  ];

  return (
    <section className="relative py-24 bg-white overflow-hidden" id="about">
      <div className="container mx-auto px-6 lg:px-12">
        
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          
          {/* LEFT SIDE: IMAGE COMPOSITION */}
          <div className="w-full lg:w-1/2 relative">
            <div className="relative">
              {/* Main Image */}
              <div className=" overflow-hidden shadow-2xl z-10 relative border-[12px] border-gray-50">
                <img 
                  src="../img/BACK.jpeg" 
                  alt="Techniker bei der Arbeit" 
                  className="w-full h-[500px] object-cover"
                />
              </div>

              {/* Floating Experience Badge */}
         

              {/* Decorative Background Element */}
              <div 
                className="absolute -top-10 -left-10 w-64 h-64 opacity-10 rounded-full blur-3xl -z-10"
                style={{ backgroundColor: brandBlue }}
              ></div>
            </div>
          </div>

          {/* RIGHT SIDE: CONTENT */}
          <div className="w-full lg:w-1/2 space-y-8">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                 <span className="w-12 h-[2px]" style={{ backgroundColor: brandRed }}></span>
                 <span className="text-xs font-black uppercase tracking-[0.3em]" style={{ color: brandRed }}>Über uns</span>
              </div>
              <h2 className="text-4xl md:text-6xl font-black leading-tight" style={{ color: brandBlue }}>
                Qualität, die man <br/> 
                <span className="text-[#ff4a4a]">spüren kann.</span>
              </h2>
              <p className="text-lg text-gray-500 leading-relaxed max-w-xl italic">
                "Ihr Wohlbefinden in den eigenen vier Wänden ist unser Ziel. Wir kombinieren traditionelles Handwerk mit innovativer Technik."
              </p>
            </div>

            {/* Value Proposition Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6">
              {valueProps.map((prop, i) => (
                <div key={i} className="flex gap-4 group">
                  <div 
                    className="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 shadow-lg"
                    style={{ backgroundColor: 'white', color: brandRed, boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}
                  >
                    {prop.icon}
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{prop.title}</h4>
                    <p className="text-sm text-gray-500 leading-snug">{prop.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Stats Bar */}
            <div className="flex flex-wrap gap-10 pt-10 border-t border-gray-100">
               {stats.map((stat, i) => (
                 <div key={i} className="flex flex-col">
                    <span className="text-3xl font-black" style={{ color: brandBlue }}>{stat.value}</span>
                    <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">{stat.label}</span>
                 </div>
               ))}
            </div>

            {/* Bottom CTA for About */}
            <div className="pt-4">
               <button 
                 className="flex items-center gap-3 font-black text-xs uppercase tracking-widest group transition-all"
                 style={{ color: brandBlue }}
               >
                 Mehr über unsere Philosophie 
                 <CheckCircle2 size={18} className="group-hover:translate-x-1 transition-transform" style={{ color: brandRed }} />
               </button>
            </div>
          </div>

        </div>
      </div>

      <style jsx>{`
        @keyframes pulse-slow {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        .animate-pulse-slow {
          animation: pulse-slow 5s infinite ease-in-out;
        }
      `}</style>
    </section>
  );
};

export default About;